import { BASE_URL } from "config";
import { api } from "utils";
import * as base from '../base';


const endpoints = {
  list: `${BASE_URL}/api/v1/server/`,
  detail: (id) => `${BASE_URL}/api/v1/server/${id}/`,
  history: (id) => `${BASE_URL}/api/v1/server/${id}/history/`,
};

export const serverListLoad = (token, payload) => api.ListLoad(endpoints.list, token, payload);
export const serverDetailLoad = (token, { id }) => api.DetailLoad(endpoints.detail, token, { id });
export const serverUpdate = (token, data) => api.Update(endpoints.list, endpoints.detail, token, data);
export const serverDelete = (token, data) => api.Delete(endpoints.detail, token, data);
export const serverHistoryLoad = (token, payload) => api.DetailLoad(endpoints.history, token, { id: payload.id });


export const server = {
  state: {
    ...base.ListState,
    ...base.DetailState,
    ...base.EditState,
    ...base.DeleteState,

    title: 'Серверы',
    urls: {
      list: () => `/server`,
      detail: (id) => `/server/${id}`,
    },
  },
  reducers: {
    ...base.ListReducers,
    ...base.DetailReducers,
    ...base.EditReducers,
    ...base.DeleteReducers,
  },
  effects: dispatch => ({
    async listLoad(payload, rootState) {
      await base.asyncListLoadRequest(dispatch, payload, rootState, 'server', serverListLoad)
    },

    async detailLoad(payload, rootState) {
      await base.asyncDetailLoadRequest(dispatch, payload, rootState, 'server', serverDetailLoad)
    },

    async update(payload, rootState) {
      await base.asyncUpdateRequest(dispatch, payload, rootState, 'server', serverUpdate);
    },

    async delete(payload, rootState) {
      await base.asyncDeleteRequest(dispatch, payload, rootState, 'server', serverDelete);
    },
  }),
}